import type { WidgetDefinition } from "@nexus/widget-sdk";
import widgetModule, { settings } from ".";

export const definition: WidgetDefinition = {
  id: "live-kpi-indicator",
  module: widgetModule,
  catalog: {
    description:
      "One or two live figures — detections, responses, anomalies — over the dashboard's time range.",
    domain: "kpis",
    visual: "KPI",
    purposes: ["live"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "content", skeleton: "kpi" },
  settings,
  defaultLayoutClassName: "col-span-12 xl:col-span-4",
};
